import {z} from 'zod'
import {createNumericKeyRecordSchema} from '../OptionalNumericKeyRecordSchema.ts'
import {createPartialStrictObjectSchemaWithAtLeastOneProperty} from '../PartialStrictObjectSchema.ts'
import {validateState} from '../ValidateState.ts'
import {PlayerColor} from '../PlayerState.ts'

// TileEdgeDirection: https://prntscr.com/w5qsqr
export enum TileEdgeDirection {
    NorthWest = 0,
    West = 1,
    SouthWest = 2,
}

export enum TileEdgeType {
    Road = 1,
    Ship = 2,
}

export const tileEdgeStateSchema = z
    .object({
        x: z.number().int().readonly(),
        y: z.number().int().readonly(),
        z: z.enum(TileEdgeDirection).readonly(),
        owner: z.enum(PlayerColor).exclude(['None']).optional(),
        type: z.enum(TileEdgeType).optional(),
    })
    .strict()

export type TileEdgeState = z.infer<typeof tileEdgeStateSchema> & {
    readonly x: number
    readonly y: number
    readonly z: TileEdgeDirection
}

export function validateTileEdgeState(data: unknown) {
    return validateState(tileEdgeStateSchema, data)
}

export const tileEdgeStatesSchema = createNumericKeyRecordSchema(tileEdgeStateSchema)
export type TileEdgeStates = z.infer<typeof tileEdgeStatesSchema>

export function validateTileEdgeStates(data: unknown) {
    return validateState(tileEdgeStatesSchema, data)
}

export const tileEdgeStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tileEdgeStateSchema)

export type TileEdgeStatePartial = z.infer<typeof tileEdgeStatePartialSchema> & {
    readonly x?: number
    readonly y?: number
    readonly z?: TileEdgeDirection
}

export function validateTileEdgeStatePartial(data: unknown) {
    return validateState(tileEdgeStatePartialSchema, data)
}

export const tileEdgeStatesPartialSchema = createNumericKeyRecordSchema(tileEdgeStatePartialSchema, {
    requireAtLeastOneEntry: true,
})
export type TileEdgeStatesPartial = z.infer<typeof tileEdgeStatesPartialSchema>

export function validateTileEdgeStatesPartial(data: unknown) {
    return validateState(tileEdgeStatesPartialSchema, data)
}
